import API from "./api";
import store from "../store/";
import ConfigAPI from "./config";

function getHypeTrain() {
  const { channelId } = store.state;

  if (!channelId) {
    throw new Error("Missing required data for fetching initial state.");
  }

  const url = `/hypetrain/${channelId}`;
  return API.get(url);
}

export default {
    getHypeTrain
};
